import { useTranslation } from 'react-i18next';
import React from 'react';
import { Namespace } from '../../../../translation/namespace';

type CarouselCounterProps = {
  current: number;
  total: number;
};
export function CarouselCounter({ current, total }: CarouselCounterProps) {
  const { t } = useTranslation(Namespace.ImageGallery);
  return (
    <div className="image-gallery__carousel-stuff-container">
      <span className="image-gallery__carousel-counter">{t('imageOf', { number: current, all: total })}</span>
    </div>
  );
}
